var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSupport = function SvgSupport(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#D5F2EA"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00C48C",
    d: "M39.823 20.637c10.716 0 19.434 8.718 19.434 19.434 0 10.716-8.718 19.434-19.434 19.434-3.92 0-7.775-1.206-11-3.42l-.37-.26-4.197.522-3.789.471 1.352-3.571 1.254-3.316a19.34 19.34 0 0 1-2.685-9.86c0-10.716 8.719-19.434 19.435-19.434zm0 2.302c-9.462 0-17.133 7.67-17.133 17.132 0 3.41.998 6.586 2.715 9.255l.228.346-1.661 4.389 5.129-.638a17.05 17.05 0 0 0 10.722 3.78c9.462 0 17.132-7.67 17.132-17.132 0-9.462-7.67-17.132-17.132-17.132zm-8.24 14.775a2.357 2.357 0 1 1 0 4.714 2.357 2.357 0 0 1 0-4.714zm8.568 0a2.357 2.357 0 1 1 0 4.714 2.357 2.357 0 0 1 0-4.714zm8.567 0a2.357 2.357 0 1 1 0 4.714 2.357 2.357 0 0 1 0-4.714z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSupport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/support.a47059f1.svg";
export { ForwardRef as ReactComponent };